import React, { useState } from "react";
import { DsButton } from "../../ds";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";

export const RejectDialog = ({ item, siblings = [], open, onOpenChange, onConfirm, busy }) => {
  const [note, setNote] = useState("");
  const [applyAll, setApplyAll] = useState(true);
  const valid = note.trim().length > 0;
  const hasGroup = siblings.length > 0;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reject-dialog">
        <DialogHeader>
          <DialogTitle>Reject {item.id}?</DialogTitle>
          <DialogDescription>
            Social Lead gets a "Social: regenerate" task with your note and sends a new version back for approval.
          </DialogDescription>
        </DialogHeader>
        {hasGroup && (
          <label className="flex items-start gap-2 text-sm cursor-pointer" data-testid="reject-apply-all-label">
            <Checkbox checked={applyAll} onCheckedChange={(v) => setApplyAll(!!v)} data-testid="reject-apply-all-checkbox" />
            <span>
              Apply to all channels of this day
              <span className="block text-xs text-[color:var(--muted)]">
                Also rejects {siblings.map((s) => s.channel).join(", ")} and creates one regenerate task for the group.
              </span>
            </span>
          </label>
        )}
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="What should change? (required)"
          rows={4}
          data-testid="reject-note-input"
        />
        <DialogFooter>
          <DsButton onClick={() => onOpenChange(false)} data-testid="reject-cancel-btn">Cancel</DsButton>
          <DsButton variant="no" disabled={!valid || busy} onClick={() => onConfirm(note.trim(), hasGroup && applyAll)} data-testid="reject-confirm-btn">
            Reject and request new version
          </DsButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
